import { gql } from "@apollo/client";
import { TypedDocumentNode } from "@apollo/client";

type GetLimitQuery = {
  vcsEventTriggeredRunsLimit: number;
  runLogRetentionDays?: number;
};

export const GET_LIMIT: TypedDocumentNode<GetLimitQuery> = gql`
  query GetLimit($isSaas: Boolean!) {
    vcsEventTriggeredRunsLimit
    runLogRetentionDays @include(if: $isSaas)
  }
`;

export const UPDATE_LIMIT = gql`
  mutation UpdateLimit($limit: Int) {
    accountUpdateVCSEventTriggeredRunsLimit(limit: $limit)
  }
`;
